/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useState} from "react";
import BookingLoginEmail from "./BookingLogin/BookingLoginEmail";
import BookingLoginEmailCode from "pages/Front/Booking/BookingLogin/BookingLoginEmailCode";

const BookingLogin = () => {
    const [email, setEmail] = useState("");
    const [securityCodeSent, setSecurityCodeSent] = useState<boolean>(false);

    if (!securityCodeSent) {
        return <BookingLoginEmail setSecurityCodeSent={setSecurityCodeSent} setEmail={setEmail} />;
    }
    return <BookingLoginEmailCode email={email} />;
};

export default BookingLogin;
